

import BehaviorOperand from './behavior_operand';
import BehaviorOperandFactory from './behavior_operand_factory';
import BehaviorExpressionOperators from '../../constants/behavior_expression_operators';

import EnumValidator from 'validator/enum_validator';

export default class BehaviorExpression extends BehaviorOperand {
	_operator;
	_leftOperand;
	_rightOperand;

	constructor(props = {}) {
		super(props);

		this._leftOperand = this._buildOperand(props.leftOperand);
		this._rightOperand = this._buildOperand(props.rightOperand);
	}

	_buildOperand(operandProps) {
		return operandProps ? BehaviorOperandFactory.create(operandProps) : {};
	}

	get operator() {
		return this._operator;
	}

	set operator(value) {
		EnumValidator.validate(value, BehaviorExpressionOperators);
		this._operator = BehaviorExpressionOperators[value];
	}

	get leftOperand() {
		return this._leftOperand;
	}

	set leftOperand(operandProps) {
		this._leftOperand = this._buildOperand(operandProps);
	}

	get rightOperand() {
		return this._rightOperand;
	}

	set rightOperand(operandProps) {
		this._rightOperand = this._buildOperand(operandProps);
	}
}
